module.exports = __webpack_public_path__ + "static/img/wfdxxzn.4ddd2ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wfdxxzn.jpg
// module id = S7iv
// module chunks = 31